import { render, staticRenderFns } from "./Pwa.vue?vue&type=template&id=10c5b0c2"
import script from "./Pwa.vue?vue&type=script&lang=js"
export * from "./Pwa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports